import React from "react";
import { Grid } from "@mui/material";

import UsersCountSummary from "../users/UsersCountSummary";
import { fCoins } from "src/utils/formatNumber";

export default function ProfileUserStats({ user }) {
  return (
    <Grid container spacing={1} sx={{ mb: 6, p: 0 }}>
      <Grid item xs={2}>
        <UsersCountSummary title="Entries" total={user.lineupsCount} />
      </Grid>
      <Grid item xs={2}>
        <UsersCountSummary title="Cards Count" total={user.cardsCount} />
      </Grid>
      <Grid item xs={2}>
        <UsersCountSummary title="IAP Purchases" total={user.purchasesCount} />
      </Grid>
      <Grid item xs={2}>
        <UsersCountSummary
          title="IAP Purchases Rev"
          total={`$${user.iapTotal}`}
        />
      </Grid>
      <Grid item xs={2}>
        <UsersCountSummary
          title="Coins Purchased"
          total={fCoins(user.buyCoinsTotal)}
          icon="/assets/icons/ufcoin.svg"
        />
      </Grid>
      <Grid item xs={2}>
        <UsersCountSummary title="Cards Sold" total={user.cardSellCount} />
      </Grid>
      <Grid item xs={2}>
        <UsersCountSummary title="Cards Bought" total={user.cardBuyCount} />
      </Grid>
      <Grid item xs={2}>
        <UsersCountSummary title="Packs Opened" total={user.packsCount} />
      </Grid>
      <Grid item xs={2}>
        <UsersCountSummary
          title="Minigames Spent"
          total={fCoins(user.gameProviderEntryAmount)}
          icon="/assets/icons/ufcoin.svg"
        />
      </Grid>
      <Grid item xs={2}>
        <UsersCountSummary
          title="Minigames Won"
          total={fCoins(user.gameProviderEntryPrize)}
          icon="/assets/icons/ufcoin.svg"
        />
      </Grid>
      <Grid item xs={2}>
        <UsersCountSummary
          title="Minigames Profit"
          total={fCoins(user.gameProviderProfit)}
          icon="/assets/icons/ufcoin.svg"
        />
      </Grid>
    </Grid>
  );
}
